import { IActionMap } from '@omaze/redux';

import { createTooltipActionType } from './Tooltip.factories';

export const TOOLTIP_ACTIONS: IActionMap = {
    ADD: createTooltipActionType('add'),
    REMOVE: createTooltipActionType('remove'),
};
